// extracted by mini-css-extract-plugin
export default {"actionWrapper":"MenuActions_actionWrapper__1Gork","name":"MenuActions_name__3opsN"};